import React from "react";

export default function BadgesGallery({ badges }) {
  return (
    <div style={{ marginTop: "2rem" }}>
      <h3 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "1.35rem",
        color: "var(--ink)",
        fontWeight: 600,
        marginBottom: "1rem",
      }}>
        Reading Badges & Accomplishments
      </h3>
      
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
        gap: "1.25rem",
      }}>
        {badges.map((badge) => {
          return (
            <div
              key={badge.id}
              style={{
                background: "var(--white)",
                border: badge.unlocked ? "1.5px solid var(--gold)" : "1px solid var(--dust)",
                borderRadius: "14px",
                padding: "1rem 1.25rem",
                boxShadow: "var(--shadow)",
                opacity: badge.unlocked ? 1 : 0.72,
                display: "flex",
                gap: "1rem",
                alignItems: "center",
                transition: "all 0.3s",
              }}
              onMouseEnter={(e) => {
                if (badge.unlocked) {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "var(--shadow-lg)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "var(--shadow)";
              }}
            >
              <div style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                filter: badge.unlocked ? "none" : "grayscale(1) contrast(0.6)",
                background: badge.unlocked ? "var(--cream)" : "var(--dust)",
                border: `1.5px solid ${badge.unlocked ? "var(--gold)" : "var(--dust)"}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.4rem",
                flexShrink: 0,
              }}>
                {badge.icon}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <h4 style={{
                  fontSize: "0.92rem",
                  fontWeight: 700,
                  color: badge.unlocked ? "var(--gold)" : "var(--muted)",
                  margin: 0,
                }}>
                  {badge.title}
                </h4>
                <p style={{
                  fontSize: "0.76rem",
                  color: badge.unlocked ? "var(--ink)" : "var(--muted)",
                  margin: "2px 0 0 0",
                  lineHeight: 1.3,
                }}>
                  {badge.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
